<template>
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20.3334" r="20" :fill="bgColor"/>
    <path d="M24.2008 17.9065L15.8008 13.0625" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M28.4006 24.0666V16.5999C28.4003 16.2726 28.3138 15.9511 28.15 15.6677C27.9862 15.3843 27.7507 15.1489 27.4673 14.9853L20.9339 11.2519C20.6502 11.0881 20.3283 11.0018 20.0006 11.0018C19.6729 11.0018 19.351 11.0881 19.0673 11.2519L12.5339 14.9853C12.2504 15.1489 12.015 15.3843 11.8511 15.6677C11.6873 15.9511 11.6009 16.2726 11.6006 16.5999V24.0666C11.6009 24.3939 11.6873 24.7154 11.8511 24.9988C12.015 25.2822 12.2504 25.5176 12.5339 25.6813L19.0673 29.4146C19.351 29.5784 19.6729 29.6647 20.0006 29.6647C20.3283 29.6647 20.6502 29.5784 20.9339 29.4146L27.4673 25.6813C27.7507 25.5176 27.9862 25.2822 28.15 24.9988C28.3138 24.7154 28.4003 24.3939 28.4006 24.0666Z" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.8525 15.6292L20.0005 20.3425L28.1485 15.6292" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.001 29.7411V20.3331" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    </template>
    
    <script>
    export default {
        props: {
            color: {
                type: String,
                default: '#A1A8B8'
            },
            bgColor: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: '16'
            },
        },
    }
    </script>